import { RootState } from "../../store/store";

export const selectLoggedIn = (state: RootState) => state.login.loggedIn;
export const selectLoading = (state: RootState) => state.login.loading;
export const selectError = (state: RootState) => state.login.error;
export const selectErrorMessage = (state: RootState) => state.login.errorMessage;
